import { render, staticRenderFns } from "./CouponSetting.vue?vue&type=template&id=23f322fc"
import script from "./CouponSetting.vue?vue&type=script&lang=js"
export * from "./CouponSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports